import { render, staticRenderFns } from "./MoreCom.vue?vue&type=template&id=48e1f0a3&scoped=true&"
import script from "./MoreCom.vue?vue&type=script&lang=js&"
export * from "./MoreCom.vue?vue&type=script&lang=js&"
import style0 from "./MoreCom.vue?vue&type=style&index=0&id=48e1f0a3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e1f0a3",
  null
  
)

export default component.exports